__turbopack_context__.v({
  "reviewCount": "review-summary-module__qH5VHG__reviewCount",
  "reviewRating": "review-summary-module__qH5VHG__reviewRating",
  "reviewSeparator": "review-summary-module__qH5VHG__reviewSeparator",
  "reviewStar": "review-summary-module__qH5VHG__reviewStar",
  "reviewStars": "review-summary-module__qH5VHG__reviewStars",
  "reviewSummary": "review-summary-module__qH5VHG__reviewSummary",
  "reviewSummaryInteractive": "review-summary-module__qH5VHG__reviewSummaryInteractive",
});
